import { sameEntityId, toFiniteNumber } from './planningNormalizers';
import { toDateKey } from './planningDates';

export const calculateDaysUntilDeadline = (event, today = new Date()) => {
  if (!event.endDate) return null;
  return Math.ceil((new Date(`${event.endDate}T12:00:00`) - new Date(`${toDateKey(today)}T12:00:00`)) / 86400000);
};
export const calculateRemainingEstimatedHours = (event) => Math.max(0, toFiniteNumber(event.remainingHours, Math.max(0, toFiniteNumber(event.estimatedHours) - toFiniteNumber(event.completedHours))));
export const isDeadlineLate = (event, today = new Date()) => { const days = calculateDaysUntilDeadline(event, today); return days != null && days < 0 && !['completed', 'cancelled'].includes(event.status); };
export const calculateCapacityBeforeDeadline = (event, capacity, today = new Date()) => capacity.filter((row) => sameEntityId(row.userId, event.resourceId) && row.date >= toDateKey(today) && row.date <= event.endDate).reduce((sum, row) => sum + row.remainingHours, 0);
export const calculateDeadlineRisk = (event, capacity, today = new Date()) => {
  if (isDeadlineLate(event, today)) return 'Retard';
  if (!event.resourceId || toFiniteNumber(event.estimatedHours) <= 0) return 'À qualifier';
  const remaining = calculateRemainingEstimatedHours(event); const available = calculateCapacityBeforeDeadline(event, capacity, today); const days = calculateDaysUntilDeadline(event, today);
  if (remaining > available || days <= 2) return 'Élevé';
  if (days <= 7 || event.progress < 50) return 'À surveiller';
  return 'Normal';
};
export const getPlanningRelationLabel = (event, references) => {
  const realization = references.realizations.find((row) => sameEntityId(row.id, event.projectId));
  return realization?.displayLabel || '—';
};
